module.exports = __webpack_public_path__ + "static/media/xray4Left.964da4a3.jpg";